const STORAGE_KEY = 'cartografika-ui-state';
const STORAGE_VERSION = 1;

interface PersistedState {
  v: number;
  viewMode: string;
  cameraType: string;
  showProjectPanel: boolean;
  showLayerPanel: boolean;
  activeLayer: string;
  envWidth: number;
  envLength: number;
  envHeight: number;
  envRotation: number;
  envSetback: number;
  envX: number;
  envY: number;
  showEnvelope: boolean;
  showMedoids: boolean;
  showLasers: boolean;
  showDrainage: boolean;
  showSetback: boolean;
  showGrid: boolean;
  showHud: boolean;
}

const PERSISTED_KEYS: (keyof PersistedState)[] = [
  'viewMode',
  'cameraType',
  'showProjectPanel',
  'showLayerPanel',
  'activeLayer',
  'envWidth',
  'envLength',
  'envHeight',
  'envRotation',
  'envSetback',
  'envX',
  'envY',
  'showEnvelope',
  'showMedoids',
  'showLasers',
  'showDrainage',
  'showSetback',
  'showGrid',
  'showHud',
];

function safeGetStorage(): Storage | null {
  try {
    if (typeof window === 'undefined') return null;
    const storage = window.localStorage;
    const testKey = '__storage_test__';
    storage.setItem(testKey, '1');
    storage.removeItem(testKey);
    return storage;
  } catch {
    return null;
  }
}

export function loadPersistedState(): Partial<PersistedState> | null {
  const storage = safeGetStorage();
  if (!storage) return null;
  try {
    const raw = storage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as PersistedState;
    if (parsed.v !== STORAGE_VERSION) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function savePersistedState(state: Partial<PersistedState>): void {
  const storage = safeGetStorage();
  if (!storage) return;
  try {
    const toSave: Partial<PersistedState> = { v: STORAGE_VERSION };
    for (const key of PERSISTED_KEYS) {
      if (key in state) {
        (toSave as any)[key] = state[key];
      }
    }
    storage.setItem(STORAGE_KEY, JSON.stringify(toSave));
  } catch {
    // ignore write errors (private browsing, quota exceeded)
  }
}

export function clearPersistedState(): void {
  const storage = safeGetStorage();
  if (!storage) return;
  try {
    storage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
